import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { parents, household } from 'selectors/tenant'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , tenants: parents(state)
	  , household: household(state, props)
	})
)

export class HeadOfHouseholdCombobox extends Component{
	render(){
		let { props } = this
		//console.log(props.household && Object(props.household.length).keys);
		return(
			<Combobox
				icon={
					<img
						src={".." + "/static/img/tenant-green.png"}
						style={{
							width: "20px",
							marginTop: '0px'
					}}/>
				}
				key={props.objectID}
				link={`/manager/tenants/${props.object.parentID}/`}
				exist={(props.object && props.object.parentID)}
				objectID={props.objectID}
				text={(props.object && props.object.parentID && props.tenants[props.object.parentID])?props.tenants[props.object.parentID].tenant || (props.tenants[props.object.parentID].firstName+" "+props.tenants[props.object.parentID].lastName):""}
				hintText={<span>Head of household</span>}
				label="Head of household"
				searchText={
					(props.object.parentID&&props.tenants[props.object.parentID])?
						props.tenants[props.object.parentID].tenant || (props.tenants[props.object.parentID].firstName+" "+props.tenants[props.object.parentID].lastName)
						: ''
				}
				dataSource={
					R.map(tenant => ({
						text: `${tenant.tenant || (tenant.firstName + " " + tenant.lastName)}`
					  , value: (
							<MenuItem
								key={tenant._id}
								primaryText={tenant.tenant || (tenant.firstName + " " + tenant.lastName)}
							/>
						)
					  , id: tenant._id
				  }), sortSev(!props.parentID && Object.keys(props.household).length ? props.household : props.tenants , "tenant", "firstName"))
				}
				onChange={(obj)=>{
						obj = obj || {}
						props.STAGE({
							_id: props.objectID
						  , parentID: obj.id
						})
					}
				}
			/>
		)
	}
}

export default connect(select, dataActions)(HeadOfHouseholdCombobox)



// WEBPACK FOOTER //
// ./src/routes/manager/tenantForm/HeadOfHouseholdCombobox.js